import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import lang from 'element-ui/lib/locale/lang/de';
import locale from 'element-ui/lib/locale';
import checkForTouch from './utils/check-for-touch';
import { getDataFromSession, setupLoginGuard } from './utils/authentication';
import addResizeListener from './utils/resize';

import CKEditor from 'ckeditor4-vue';

import { func } from './functions.js';

checkForTouch();
addResizeListener();

getDataFromSession();
setupLoginGuard();

locale.use(lang);

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(CKEditor);

Vue.prototype.$confirm = ElementUI.MessageBox.confirm;
Vue.prototype.$alert = ElementUI.MessageBox.alert;
Vue.prototype.$func = func;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');

var removecache = true;
console.log(removecache);
